import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, MenuController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import { HomePage } from '../home/home';
import { ENV } from '@app/env'
import { ProgramShipmentsPage } from '../program-shipments/program-shipments';
import { PatientsPage } from '../patients/patients';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  credentialsForm: FormGroup;
  versionnumber: any;
  environment: string;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private auth: AuthProvider,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public menu: MenuController,
  ) {
    this.menu.enable(false);

    this.credentialsForm = this.formBuilder.group({
      email: [''],
      password: ['']
    });

    this.versionnumber = ENV.VERSION;
    this.environment = ENV.MODE;
  }

  ionViewDidLoad() {}
  
  ionViewWillEnter() {
    this.menu.enable(false);
  }
    
    
ionViewWillLeave() {
    this.menu.enable(true);
}

async signup()  {
  let email = this.credentialsForm.controls.email.value;
  let password = this.credentialsForm.controls.password.value;
  const loader = this.loadingCtrl.create({
    content: "Signing In..."
  });

  loader.present()
  let test: any = {}
  await this.auth.emailSignUp(email, password, test)
  .then(() => {
    loader.dismiss()
  })
  .catch((err) => {
    console.log(err)
    let error: string = err.toString();
    error = error.replace('Error: Error: ','');
    loader.dismiss()
    const alert = this.alertCtrl.create({
      title: 'Login Failure',
      subTitle: error,
      buttons: ['OK']
    });
    alert.present();
  });
}
  async login() {
    let email = this.credentialsForm.controls.email.value;
    let password = this.credentialsForm.controls.password.value;
    if(!email || !password) {
      const alert = this.alertCtrl.create({
        title: 'Login Failure',
        subTitle: 'Please enter a valid email and password',
        buttons: ['OK']
      });
      alert.present();
      return
    }
    const loader = this.loadingCtrl.create({
      content: "Signing In..."
    });

    loader.present()

    await this.auth.emailLogin(email, password)
    .then(() => {
      loader.dismiss()
      this.auth.getCurrentUser()
      .then(user => { 

        if (user) {
          if (user.roles.warehouse)  {
            this.navCtrl.setRoot(ProgramShipmentsPage)
          } else if (user.roles.secureupload)  {
            this.navCtrl.setRoot(HomePage)
          } else if (user.roles.navigator_super)  {
            this.navCtrl.setRoot(PatientsPage)
          } else {
            this.navCtrl.setRoot(HomePage)
          }
        } 
    })
      
    })
    .catch((err) => {
      console.log(err)
      let error: string = err.toString();
      error = error.replace('Error: Error: ','');
      loader.dismiss()
      const alert = this.alertCtrl.create({
        title: 'Login Failure',
        subTitle: error,
        buttons: ['OK']
      });
      alert.present();
    });

    
  }

  async resetPassword() {
    const emailprompt = this.alertCtrl.create({
      title: 'Reset Password',
      inputs: [
        {
          name: 'email',
          placeholder: 'Email'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Send Reset Email',
          handler: data => {
            let emailaddress = data.email;
            console.log("Email: ", emailaddress);
            const loader = this.loadingCtrl.create({
              content: "Sending Reset Email..."
            });
        
            loader.present()
        
            this.auth.sendPasswordResetEmail(emailaddress)
            .then(() => {
              loader.dismiss()
            })
            .catch(() => {
              loader.dismiss()
            });

        
            
          }
          }
      ]
    });
    emailprompt.present();
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts